<template>
	<div>
		<v-dialog v-model="dialog_rating" no-click-animation transition="slide-y-transition" max-width="290">
	      <v-card>
	      	<v-card-title class="title noshadow pt-4" style="justify-content:center">
	      		Do you like BizOps App?
	      		<!-- <v-spacer></v-spacer>
	      		<v-btn flat icon @click="$parent.fn_closeDialog"><v-icon>close</v-icon></v-btn> -->
	      	</v-card-title>
	      	<!-- <v-divider></v-divider> -->
	        <v-card-text class="pt-5 pb-5">
	        	<div class="text-xs-center">
			    	<v-btn icon nomargin @click="rating=1"><v-icon style="font-size:32px;color:#f9a825 !important">{{rating >= 1 ? 'star' : 'star_border'}}</v-icon></v-btn>
			    	<v-btn icon nomargin @click="rating=2"><v-icon style="font-size:32px;color:#f9a825 !important">{{rating >= 2 ? 'star' : 'star_border'}}</v-icon></v-btn>
			    	<v-btn icon nomargin @click="rating=3"><v-icon style="font-size:32px;color:#f9a825 !important">{{rating >= 3 ? 'star' : 'star_border'}}</v-icon></v-btn>
			    	<v-btn icon nomargin @click="rating=4"><v-icon style="font-size:32px;color:#f9a825 !important">{{rating >= 4 ? 'star' : 'star_border'}}</v-icon></v-btn>
			    	<v-btn icon nomargin @click="rating=5"><v-icon style="font-size:32px;color:#f9a825 !important">{{rating == 5 ? 'star' : 'star_border'}}</v-icon></v-btn>
			  	</div>
	        </v-card-text>
	        <!-- <v-divider></v-divider> -->
	        <!-- Data has been saved as draft. What would you like to do? -->
	        <v-card-actions style="padding:6px 0px;" center-align>
	        	<v-layout wrap>
                    <v-flex xs6 sm6 md6>
	        			<v-btn capitalize flat @click="closeDialog">Later</v-btn>
	        	  	</v-flex>
	        		<v-flex xs6 sm6 md6>
	        			<v-btn color="primary" capitalize flat @click="fn_rating">Done</v-btn>
	        	  	</v-flex>
	        	</v-layout>
		    </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>	 	

<script>

export default{
	props:['closeDialog', 'save'],
	data(){	
		return{
			dialog_rating: false,
			rating:0
		}
	},
	methods: {
		openDialogWeb: function () {
			this.rating	= 0;
			this.dialog_rating = true;
		},
		closeDialogWeb: function () {
			this.dialog_rating = false;
		},
		fn_rating: function(){
			this.closeDialog();
			this.save(this.rating);
		}
		// fn_save: function(rate){
		// 	this.closeDialog();
		// 	this.save(rate);
		// }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_rating.vue